module.exports = __webpack_public_path__ + "img/notebook-unactive.b78a5e2.svg";